import { Component, ViewChild } from '@angular/core';
import { MainHeaderComponent } from "../../shared/main-header/main-header.component";
import { DataTableComponent } from "../../shared/data-table/data-table.component";

import { Task } from '../../../models/task';
import { Models } from '../../../models/models';
import { firstValueFrom, Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, RouterLink } from '@angular/router';
import { Table } from 'primeng/table';
import { MatButtonModule } from '@angular/material/button';
import { ModelsService } from '../../../services/models.service';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-list',
  standalone: true,
  imports: [MainHeaderComponent, DataTableComponent, RouterLink, MatButtonModule, CommonModule],
  templateUrl: './list.component.html',
  styleUrl: './list.component.scss'
})
export class ListModelssComponent {
  models: Models[] = [];
  selected!: Models[];
  products!: Models[];
  selectedProducts: Models[] = [];

  selectedItems: any[] = [];

  columns: any[] = [
    { field: 'model_id', header: 'Id', filter: true, orderby: true },
    { field: 'name', header: 'Nombre', filter: true, orderby: false },
    { field: 'description', header: 'Descripcion', filter: true, orderby: false },
    { field: 'server', header: 'Servidor', filter: true, orderby: false },
    { field: 'server_path', header: 'Ruta del Servidor', filter: true, orderby: false },
    { field: 'version', header: 'Version', filter: true, orderby: false },
    { field: 'model_key', header: 'Llave', filter: true, orderby: false },
    { field: 'is_active', header: 'Activo', filter: true, orderby: false },
  ];

  @ViewChild('dt') table!: Table;
  constructor(public modelsService: ModelsService, private _snackBar: MatSnackBar, private router: Router) { }

  ngOnInit(): void {
    this.modelsService.loadModelsStore().subscribe((models: any) => {
      this.models = models.data;
    });
    console.log("tabla____", this.table);
  }

  onSelectionChange(event: any) {
    console.log('event', event);
    this.selectedProducts = event;
  }

  onEditItem(item: any) {
    console.log('onEditItem items:', item);
    this.router.navigate(['/models', item.model_id]);
  }
  async onDeleteItems(items: any) {
    console.log('Delete items:', items);
    if (window.confirm("Esto eliminará este modelo y todas sus configuraciones")) {
      const deletePromise =  firstValueFrom(this.modelsService.deleteModels(items.model_id));
      await deletePromise;
       const resp = await firstValueFrom(this.modelsService.loadModelsStore())
        this.models = resp.data;
        this.selectedProducts = []
        console.log('modelo delete')
        this._snackBar.open(`Modelo ${items.model_id} eliminado.`, 'ok');
    }
  }


  async deleteModel(model: Models[]) {
    if (window.confirm("Esto eliminará este modelo y todas sus configuraciones")) {
      try {
        const deletePromise = model.map(model => firstValueFrom(this.modelsService.deleteModels(model.model_id)));
        await Promise.all(deletePromise);
        const resp = await firstValueFrom(this.modelsService.loadModelsStore())
        this.models = resp.data;
        this.selectedProducts = [];
        this._snackBar.open('Modelos eliminados', 'ok', { duration: 3000 });
      } catch (error) {
        console.error('Error deleting models:', error);
        this._snackBar.open('Error eliminando modelos', 'ok', { duration: 3000 });
      }
    }
  }

  
  onRowSelect(event: any) {
    console.log('select', this.selectedProducts)


  }
}







